export const keys = {
  all: ['copro'] as const,
  bySpace: (spaceId: string) => ['copro', spaceId] as const,
};